import { render, staticRenderFns } from "./font.vue?vue&type=template&id=25e8a230&scoped=true&"
import script from "./font.vue?vue&type=script&lang=js&"
export * from "./font.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e8a230",
  null
  
)

export default component.exports